<template>
	<edit-template>
    <el-form ref="form" :model="form" :rules="rules" class="form-body" label-width="160rem" style="padding-top: 70rem;padding-left: 100rem">
			<el-form-item label="商品名称" prop="goods_name">
				<el-input v-model="form.goods_name" class="independentStyle" placeholder="请输入商品名称"></el-input>
			</el-form-item>
			<el-form-item label="商品类型" prop="goods_category">
				<el-select v-model="form.goods_category" placeholder="请选择商品类型" @change="goodsCategoryChange">
					<el-option v-for="item in goodsCategory" :label="item.label" :value="item.value"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="收费方式" prop="goods_type">
				<el-select v-model="form.goods_type" placeholder="请选择收费方式" value="">
					<el-option label="一次收费" :value="1"></el-option>
					<el-option label="多次收费" :value="2"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="是否支持分期" prop="is_by_stages">
				<el-select v-model="form.is_by_stages" placeholder="请选择是否支持分期" value="">
					<el-option label="是" :value="1"></el-option>
					<el-option label="否" :value="0"></el-option>
				</el-select>
			</el-form-item>
      <el-form-item label="所支持缴费计划" class="z-no-margin-bottom mb-2" v-if="form.is_by_stages === 1">
        <div class="z-dynamic-list-item" v-for="(domain, index) in form.stages_plan" :key="domain.id">
          <div class="flex z-dynamic-list-inner">
            <el-form-item labelWidth="0" :prop="`stages_plan.${index}.stages_mode`" :rules="dynamicValidate">
              <el-select v-model="domain.stages_mode" placeholder="请选择分期方式" @change="onTypeChange($event, index)">
                <el-option v-for="item in typeOptions" :key="item.value" :label="item.label" :value="item.value" :disabled="item.disabled"></el-option>
              </el-select>
            </el-form-item>
            <div class="px-2 text-gray">-</div>
            <el-form-item labelWidth="0" :prop="`stages_plan.${index}.installment_count`" :rules="dynamicValidate">
              <el-select v-model="domain.installment_count" placeholder="请选择分期数" :disabled="domain.disabled">
                <el-option v-for="item in scoreOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </div>
          <el-form-item label-width="40rem">
            <el-button icon="el-icon-delete" circle v-if="form.stages_plan.length !== 1" @click.prevent="handelRemove(domain)"></el-button>
            <el-button icon="el-icon-plus" circle v-if="form.stages_plan.length !== dynamicMaxlength && index === form.stages_plan.length - 1" @click="handleAdd"></el-button>
          </el-form-item>
        </div>
      </el-form-item>
			<el-form-item :label="`${form.goods_category === 0 ? '普高线上学费价格' : '商品价格'}`" prop="goods_price">
				<el-input v-model="form.goods_price" :maxlength="20" :placeholder="`${form.goods_category === 0 ? '请输入普高线上学费价格' : '请输入商品价格'}`"></el-input>
			</el-form-item>
			<el-form-item v-if="form.goods_category === 0" label="本校直升优惠金额" prop="goods_price_below">
				<el-input v-model="form.goods_price_below" :maxlength="20" placeholder="请输入本校直升优惠金额"></el-input>
			</el-form-item>
		</el-form>
    <Dialog :visible.sync="visible" title="历史记录" showLine :showFooter="false">
      <TimeLine :list="list" :loading="loading" reverse></TimeLine>
    </Dialog>
    <template slot="footer">
      <el-button type="primary" @click="onPreserve">保存</el-button>
      <el-button @click="onBack">取消</el-button>
      <el-button type="primary" @click="onShow" v-if="id">查看历史记录</el-button>
    </template>
</edit-template>
</template>

<script>
import Dialog from '@/components/common/Dialog'
import TimeLine from '@/components/common/TimeLine'
import { validateNumber } from '@/utils/validate'
import http, { changeObjToArr, get_recruit_dict } from '@/api'
import { objectIsEmpty } from '@/utils'
export default {
  _config:{'route':[{'path':'edit','meta':{'title':'编辑'}}, {'path':'add','meta':{'title':'新增'}}]},
  components: { Dialog, TimeLine },

  data() { // 这里存放数据
    const v1 = (_r, value, callback) => {
      if (value === '') return callback(new Error(`请输入${this.form.goods_category === 0 ? '线上普高线价格' : '商品价格'}`))
      if (this.form.goods_category === 12) {
        return validateNumber(value, callback, { min: -1000000, max: 1000000, equalToMin: false, equalToMax: false })
      }
      if (this.form.goods_category === 0 && this.form.goods_price_below) {
        this.$refs.form.validateField('goods_price_below')
      }
      validateNumber(value, callback, { min: 0, max: 1000000, equalToMin: true, equalToMax: false })
    }
    const v2 = (_r, value, callback) => {
      if (value === '') {
        return callback(new Error('请输入本校直升优惠金额'))
      }
      const num1 = Number(this.form.goods_price)
      const num2 = Number(value)
      if (num2 > num1) {
        return callback(new Error('本校直升优惠金额不能大于普高线上学费价格'))
      }
      validateNumber(value, callback, { min: 0, max: 1000000, equalToMin: true, equalToMax: false })
    }
    const ESValidateSubject =  (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请选择'))
      } else {
        const list = this.form.stages_plan.map(item => item.subject_id)
        let result = list.filter(item => item === value)
        if(result.length > 1) callback('考试科目名称有重复，请更正后提交')
        callback()
      }
    }
		return {
      id: '',
      visible: false,
      loading: false,
      list: [],
			form: {
				goods_name: '',
				goods_category: '',
        goods_type: '',
        is_by_stages: '',
        stages_plan: [],
				goods_price: '',
        goods_price_below: ''
			},
			rules: {
				goods_name: [
					{required: true, message: '请输入商品名称', trigger: 'change'},
					{min: 1, max: 20, message: '请输入1至20个字符', trigger: 'change'},
				],
				goods_type: [
					{required: true, message: '请选择收费方式', trigger: 'change'},
				],
				is_by_stages: [
					{required: true, message: '请选择是否支持分期', trigger: 'change'},
				],
				goods_category: [
					{required: true, message: '请选择商品类型', trigger: 'change'},
				],
				goods_price: [
          {required: true, validator: v1, trigger: 'change'},
				],
				goods_price_below: [
          {required: true, validator: v2, trigger: 'change'},
				],
			},
      typeOptions: [],
      scoreOptions: [],
      dynamicMaxlength: 10,
      dynamicValidate: { required: true, message: '请选择', trigger: 'change' },
			goodsCategory: []
		};
  },

  mounted() { // 生命周期 - 挂载完成（可以访问 DOM 元素）
		this.getConfig()
    const id = this.$route.query.id
    if (this.$route.path.includes('add')) {
      this.handleAdd()
    }
    this.getConfig()
    if (!id) return
    this.id = id
    this.getData(id)
  },

  methods: { // 方法合集
    getConfig () {
      http({ url: '/recruit/goods-manage/get-goods-category', pre: 'zs'}).then(res => {
        this.goodsCategory = changeObjToArr(res, true)
      })
      get_recruit_dict().then(res => {
        this.typeOptions = res.stages_mode.map(i => ({ ...i, disabled: i.value !== 1 }))
      })
      const list = []
      for (let i = 2; i <= 12; i++) {
        list.push({ label: `${i}期`, value: i })
      }
      this.scoreOptions = list
    },
    onTypeChange(val, idx) {
      if (val === 1) {
        this.form.stages_plan[idx].installment_count = 2
        this.form.stages_plan[idx].disabled = true
      } else {
        this.form.stages_plan[idx].installment_count = ''
        if (!this.form.stages_plan[idx].disabled) return
        this.form.stages_plan[idx].disabled = false
      }
    },
    getData(id) {
      http({ url: '/recruit/goods-manage/goods-one', pre: 'zs'}, { goods_id: id }).then(res => {
        const { goods_name, goods_category, goods_type, goods_price, goods_price_below, is_by_stages, stages_plan = [] } = res
        this.form.goods_name = goods_name
        this.form.goods_category = goods_category
        this.form.goods_type = goods_type
        this.form.goods_price = goods_price
        this.form.goods_price_below = goods_price_below || ''
        this.form.is_by_stages = is_by_stages
        if (is_by_stages === 1) {
          const id = Date.now()
          this.form.stages_plan = stages_plan.map((i, j) => ({ ...i, id: id + j, disabled: i.stages_mode === 1 }))
        } else {
          this.handleAdd()
        }
      })
    },
    handleAdd() {
      if (this.dynamicMaxlength <= this.form.stages_plan.length) {
        return this.$message.warning(`最多只能添加${this.dynamicMaxlength}条`);
      }
      this.form.stages_plan.push({ id: Date.now(), stages_mode:'', installment_count: '', disabled: false , isAdd: 1 })
    },
    handleDelete(item) {
      const index = this.form.stages_plan.indexOf(item)
      if (!~index) return
      this.form.stages_plan.splice(index, 1)
    },
    handelRemove(item) {
      const { id, ...other } = item
      if(objectIsEmpty(other, ['isAdd'])) return this.handleDelete(item)
      this.$confirm('此操作将删除该项, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        beforeClose: (action, _instance, done) => {
          if (action === 'confirm') this.handleDelete(item)
          done()
        }
      }).then(() => {
        this.$message({ type: 'success', message: `删除成功!` })
      })
    },
    onShow() {
      this.visible = true
      this.getHistory()
    },
    getHistory() {
      this.loading = true
      http.get('/zhaosheng/api/recruit/common/get-opt-history', { tbl_name:'goods', tbl_id: this.id }).then(res => {
        const { list = [] } = res
        this.list = list.map(i => ({ content: i.change_detail }))
      }).finally(() => {
        this.loading = false
      })
    },
    onBack() {
      this.$confirm('是否取消保存并返回', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
				type: 'warning',
			}).then(() => {
				this.$router.back();
			});
		},
		onPreserve() {
			this.$refs.form.validate((valid) => {
				if (valid) {
          const { goods_category, goods_price, goods_price_below, stages_plan, ...other } = this.form
          const data = { ...other, goods_category }
          data.goods_price = Number(goods_price)
          if (goods_category === 0) {
            data.goods_price_below = Number(goods_price_below)
          }
          if (this.id) {
            data.goods_id = this.id
          }
          if (data.is_by_stages) {
            const arr = stages_plan.map(i => {
              const { stages_mode, installment_count } = i
              return { stages_mode, installment_count }
            })
            data.stages_plan = arr
          }
          const api = `api/recruit/goods-manage/${this.id ? 'edit' : 'add'}-goods`
					this.$_register.post(api, data).then(res => {
						if (res.data.status === 0) {
							this.$message.success(`${this.id ? '修改' : '新增'}成功`);
							this.$router.back();
              if (!this.id) {
                this.$store.commit('setPage', 1)
              }
						} else this.$message.error(res.data.msg)
					})
				}
			});
		},
		onChangePrice(v) {
			this.form.goods_price = v.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace(/^0\d[0-9]*/g, '').replace(/^(\d+)\.(\d\d).*$/, '$1.$2')
		},
		onChangeGoodsPriceBelow(v) {
			this.form.goods_price_below = v.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace(/^0\d[0-9]*/g, '').replace(/^(\d+)\.(\d\d).*$/, '$1.$2')
		},
		goodsCategoryChange(val) {
			this.$nextTick(() => this.$refs.form.clearValidate('goods_price'))
		}
	},
};
</script>

<style lang="scss" scoped>
@media only screen and (min-width: 1140rem) {
	.independentStyle {
		width: 30.13888888888888vw !important;
		/*min-width:250rem;*/
		max-width: 100%;
	}
}

@media only screen and (max-width: 1139rem) {
	.independentStyle {
		width: 500rem !important;
		max-width: 100%;
	}
}
</style>
